import { render, staticRenderFns } from "./BusinessFeatures.vue?vue&type=template&id=2e7a30ba&scoped=true&"
import script from "./BusinessFeatures.vue?vue&type=script&lang=js&"
export * from "./BusinessFeatures.vue?vue&type=script&lang=js&"
import style0 from "./BusinessFeatures.vue?vue&type=style&index=0&id=2e7a30ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7a30ba",
  null
  
)

export default component.exports